<div class="cms-text-display {className || ''}" style={customStyle}>
  {#if text}
    <div class={text.type === 'html' ? 'cms-text__html' : 'cms-text__md'}>
      {@html text.data}
    </div>
  {/if}
</div>

<script>
  export let customStyle = null
  export let className = null
  export let text = {
    type: 'html',
    data: '',
  }

  if (text && typeof text === 'object') {
    text.type = text.type || 'html'
    text.data = text.data || ''
  }
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>